
export default {
    values: {
        'Operations gantt': 'Operations gantt',
        'Shows a gantt chart displaying the operations': 'Shows a gantt chart displaying the operations',
        'Filters and settings are displayed in visualization mode only.':
            'Filters and settings are displayed in visualization mode only.',
        'Save this widget and return to the dashboard.': 'Save this widget and return to the dashboard.'
    }
}
